import React from 'react';
import { CTAButton } from './CTAButton';
import { MockupImage } from './MockupImage';
import { TrustLine } from './TrustLine';
import { OFFER_ANCHOR } from '../data/constants';
export function Hero() {
  return <section className="border-b-4 border-tech bg-ice" data-id="element-76" data-mp="9lv0spiridvb">
      <div className="h-1.5 bg-navy" aria-hidden="true" data-id="element-77" data-mp="9ih0dmtnseqi" />
      <div className="h-1 bg-tech" aria-hidden="true" data-id="element-78" data-mp="4n1j0kwg00pc" />
      <div className="mx-auto max-w-5xl px-4 pb-5 pt-3 sm:px-6 sm:pb-7 sm:pt-5" data-id="element-79" data-mp="1297a3xzwwp6o">
        <h1 className="mx-auto max-w-4xl text-center text-3xl leading-display text-navy sm:text-6xl" data-id="element-80" data-mp="1274nlnxyxe6p">
          THE COMPLETE PROFESSIONAL WELD INSPECTION{' '}
          <span className="text-tech" data-id="element-81" data-mp="sa027qby5mqy">&amp; DEFECT IDENTIFICATION VISUAL SYSTEM</span>
        </h1>
        <p className="mx-auto mt-2 max-w-3xl rounded-lg bg-navy px-3 py-1.5 text-center font-display text-sm font-bold uppercase leading-tight text-white sm:text-lg" data-id="element-82" data-mp="nbey3ftkqix8">
          STOP STRUGGLING TO IDENTIFY WELD DEFECTS THROUGH TECHNICAL MANUALS ALONE.{' '}
          <span className="text-gold" data-id="element-83" data-mp="3j8selyn99fos">START SEEING WHAT YOU'RE INSPECTING.</span>
        </p>

        <p className="mx-auto mt-2 max-w-3xl text-center text-sm leading-snug text-steel sm:text-base" data-id="element-84" data-mp="3o7lv7zxu9mt6">
          Identify weld discontinuities, understand inspection procedures, measure weld geometry,
          explore NDT methods, evaluate inspection findings, and organize professional weld
          quality reports—
          <strong className="font-semibold text-navy" data-id="element-85" data-mp="30hrg1bq1rm5r">
            all in one complete visual reference system.
          </strong>
        </p>

        <MockupImage className="mt-2" priority data-id="element-86" data-mp="35a2h4hwixdzw" />

        <div className="mt-2 flex flex-col items-center" data-id="element-87" data-mp="2qkdaw89kqjsr">
          <CTAButton href={OFFER_ANCHOR} data-id="element-88" data-mp="2qhqwboo9n411">
            🚀 YES! I WANT MY WELDING INSPECTION VISUAL ATLAS NOW
          </CTAButton>
          <TrustLine items={['🛡️ 7-Day Money-Back Guarantee — Zero Risk']} data-id="element-89" data-mp="2hjf3dfzxfu5f" />
        </div>
      </div>
    </section>;
}